import React from 'react';
import {connect} from 'react-redux';

import {doSignout} from 'next-authentication-commons/authentication/actions/authentication-actions';
import AuthContainer from 'next-authentication-commons/authentication/components/AuthContainer';
import Grid from '@mui/material/Grid';
import Text from 'dc/content/Text';

class SignOutContainer extends React.Component {

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(doSignout())
  }

  render() {
    const {redirectRoute='/',globalConfiguration} = this.props;
    debugger;
    return (
        <Grid container justify='center'>
          <Grid item xs>
            <AuthContainer globalConfiguration={globalConfiguration} userRequired redirect={redirectRoute}>
              <Text type='body2'>
                Signing out...
              </Text>
            </AuthContainer>
          </Grid>
        </Grid>
    )
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(SignOutContainer);
